import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  Content,
  ImgWrap,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import OnePageLayout from "../../components/layout/OnePageLayout";
import ImgWay1 from "../../styles/images/img_amo_add1.png";
import ImgWay2 from "../../styles/images/img_amo_add2.png";
import ImgWay3 from "../../styles/images/img_amo_add3.png";
import ImgWay4 from "../../styles/images/img_amo_add4.png";
import ImgWay5 from "../../styles/images/img_amo_add5.png";
const WalletGuide = () => {
  const navigate = useNavigate();
  return (
    <OnePageLayout title="주소등록 가이드">
      <Section>
        <Content>
          <TextDiv>
            <h3>부리또 월렛 아모 코인 추가 하는 방법</h3>
          </TextDiv>
          <WayContent>
            <article>
              <WayTitle>
                <div className="number">01</div>
                <p>지갑 - 코인추가 버튼 클릭</p>
              </WayTitle>
              <ImgWrap margintop="2">
                <img src={ImgWay1} alt="" />
              </ImgWrap>
            </article>
            <article>
              <WayTitle>
                <div className="number">02</div>
                <p>AMO 검색후 클레이튼 AMO 체크</p>
              </WayTitle>
              <ImgWrap margintop="2">
                <img src={ImgWay2} alt="" />
              </ImgWrap>
            </article>
            <article>
              <WayTitle>
                <div className="number">03</div>
                <p>AMO 코인 클릭</p>
              </WayTitle>
              <ImgWrap margintop="2">
                <img src={ImgWay3} alt="" />
              </ImgWrap>
            </article>
            <article>
              <WayTitle>
                <div className="number">04</div>
                <p>표시한 부분을 클릭 하여 주소 복사하기</p>
              </WayTitle>
              <ImgWrap margintop="2">
                <img src={ImgWay4} alt="" />
              </ImgWrap>
            </article>
            <article>
              <WayTitle>
                <div className="number">05</div>
                <p>주소가 복사되었어요. 메세지 확인하면 복사 완료</p>
              </WayTitle>
              <ImgWrap margintop="2">
                <img src={ImgWay5} alt="" />
              </ImgWrap>
            </article>
          </WayContent>
        </Content>
        <Btns>
          <ButtonL onClick={() => navigate(-1)}>확인</ButtonL>
        </Btns>
      </Section>
    </OnePageLayout>
  );
};

export default WalletGuide;
const WayContent = styled.div`
  padding-bottom: 6rem;
  article {
    margin-top: 5rem;
    img {
      width: 100%;
      max-width: 40rem;
    }
  }
`;
const WayTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .number {
    margin-right: 1.2rem;
    border-radius: 100%;
    color: ${({ theme }) => theme.color.white};
    text-align: center;
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 2.8rem; /* 116.667% */
    width: 2.8rem;
    height: 2.8rem;
    flex-shrink: 0;
    background-color: ${({ theme }) => theme.color.purple_primary};
  }
  p {
    font-size: 1.4rem;
    line-height: 1.4rem; /* 100% */
  }
`;
